import { createSlice } from "@reduxjs/toolkit";
import { NEWS } from "../../db/data";


const initialState = { news: [] };

const newsSlice = createSlice({

    name: "news",
    initialState,
    reducers: {
        loadNews : (state, action) => {
            state.news = NEWS ;
        },
        addNews : (state, action) => {
            state.news.push(action.payload);
        }
    }
});

//export slice reducer and action creators
export default newsSlice.reducer;
export const {loadNews, addNews} = newsSlice.actions; 

//export state slice news 
export const selectNews = state => state.news ;